import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext';
import ExtensionAutoConnect from './components/extension/ExtensionAutoConnect';
import AppRoutes from './routes/AppRoutes';
import { ROUTER_BASENAME } from './config/routerBasename';
import { ROUTER_FUTURE_FLAGS } from './config/routerFuture';
import { queryClient } from './lib/queryClient';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ExtensionAutoConnect />
        <Router basename={ROUTER_BASENAME} future={ROUTER_FUTURE_FLAGS}>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
